
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/NetworkGraph/index.en.md?watch=parent';
    export const demoIndex = {
  ids: ["networkgraph-demo-common","networkgraph-demo-markdown"],
  getter: () => import(/* webpackChunkName: "meta__NetworkGraph__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/NetworkGraph/index.en.md?type=demo')
};